app.controller("navCtrl", [
  "$scope",
  "$localStorage",
  "$rootScope",
  "checkUser",
  "cart",
  "$interval",
  "$location",
  "getSiteDetails",
  "config",
  function (
    $scope,
    $localStorage,
    $rootScope,
    checkUser,
    cart,
    $interval,
    $location,
    getSiteDetails,
    config
  ) {
    const siteConfig = config.fullSite;

    const location = window.location.search;
    const params = new URLSearchParams(location);
    if (params.get("redirect") === "orderComplete") {
      let siteUrl = fullSite.siteURL;
      window.location.assign(
        `${siteUrl}/#/order/111/complete?payment_intent=${params.get(
          "payment_intent"
        )}&payment_intent_client_secret=${params.get(
          "payment_intent_client_secret"
        )}`
      );
    }

    if ($location.path().search("tessitura") == -1) {
      checkUser.verifyLogin(() => {
        getSiteDetails.getCustomerContent();
      });
    }

    $scope.isLoggedIn = function () {
      return checkUser.isLoggedIn();
    };

    $scope.headerLogoURL = siteConfig.headerLogoURL;
    $scope.cartActive = siteConfig.cartActive;

    if (siteConfig.concurrencyCheckInterval_MS == undefined) {
      siteConfig.concurrencyCheckInterval_MS = 36000;
    }

    let concurrencyCheckInterval = parseInt(
      siteConfig.concurrencyCheckInterval_MS
    );

    var cartDetails = cart.getCartQty();
    $rootScope.cartNumber = cartDetails.qty;

    $scope.loggedIn = { isLoggedIn: false };

    if (navBar) {
      let navbarStyle = navBar.style;
      $scope.style = {
        backgroundColor: navbarStyle.backgroundColor || "#2bbbad",
        textColor: navbarStyle.textColor || "#FFF",
      };

      if (navBar.links) {
        $scope.links = navBar.links;
      } else {
        $scope.links = [
          {
            type: "link",
            payload: {
              label: "Home",
              linkUrl: "/#/home",
              id: "homeLink",
              loginRequired: false,
              icon: "fa-key",
            },
          },
          {
            type: "link",
            payload: {
              label: "FAQ",
              linkUrl: "/#/faq",
              id: "faqLink",
              loginRequired: false,
              icon: "fa-key",
            },
          },
          {
            type: "nested",
            payload: {
              label: "Account",
              loginRequire: true,
              contents: [
                {
                  type: "link",
                  payload: {
                    label: "Manage Account Details",
                    linkUrl: "/#/manageAccount",
                    icon: "fa-list-alt",
                    loginRequired: true,
                  },
                },
                {
                  type: "link",
                  payload: {
                    label: "Change Password",
                    linkUrl: "/#/changePassword",
                    icon: "fa-key",
                    loginRequired: true,
                  },
                },
              ],
            },
          },
          {
            type: "register",
            payload: {
              label: "Register",
            },
          },
          {
            type: "cart",
          },
          {
            type: "login",
          },
        ];
      }

      // logos
      let navbarLogo = navBar.logo;
      $scope.logo = {
        imgUrl: navbarLogo.imgUrl,
        linkUrl: navbarLogo.linkUrl || "/#/home",
        height: navbarLogo.height,
      };
    } else {
      $scope.style = {
        backgroundColor: "#2bbbad",
        textColor: "#FFF",
      };

      $scope.links = [
        {
          type: "link",
          payload: {
            label: "Home",
            linkUrl: "/#/home",
            id: "homeLink",
            loginRequired: false,
            icon: "fa-key",
          },
        },
        {
          type: "link",
          payload: {
            label: "FAQ",
            linkUrl: "/#/faq",
            id: "faqLink",
            loginRequired: false,
            icon: "fa-key",
          },
        },
        {
          type: "nested",
          payload: {
            label: "Account",
            loginRequire: true,
            contents: [
              {
                type: "link",
                payload: {
                  label: "Manage Account Details",
                  linkUrl: "/#/manageAccount",
                  icon: "fa-list-alt",
                  loginRequired: true,
                },
              },
              {
                type: "link",
                payload: {
                  label: "Change Password",
                  linkUrl: "/#/changePassword",
                  icon: "fa-key",
                  loginRequired: true,
                },
              },
            ],
          },
        },
        {
          type: "register",
          payload: {
            label: "Register",
          },
        },
        {
          type: "cart",
        },
        {
          type: "login",
        },
      ];
    }

    $scope.hide = function ($event) {
      jQuery("li.active").removeClass("active");
      jQuery(".navbar-collapse").collapse("hide");
    };

    $rootScope.checkDoubleLoginInterval = $interval(function () {
      if ($scope.isLoggedIn && siteConfig.concurrentUsers > 0) {
        checkUser.checkDoubleLogin();
      }
    }, concurrencyCheckInterval); //set from the db now

    // Make sure that the interval is destroyed too
    $scope.$on("$destroy", function () {
      $interval.cancel(loggedInInterval);
      $interval.cancel($rootScope.checkDoubleLoginInterval);
    });
  },
]);
